export default "__VITE_ASSET__8aa9b127__"